export const DONATION_CONTRACT_ADDRESS =
  "0x4F3457899108c7Ae7aeeA8c99C4C2eE6b8eFC4E6";
// "0x1d736F20dfa1913D00A7990551b1226b34793545";
export const ACCESS_KEY_ID = "KASKAWX9OCIAR71UM6Q3VF6T";
export const SECRET_ACCRESS_KEY = "Jm7DGEKbCVl3yWtK-iHJwKWfcFBTfDHn5a1bFkO6";
export const CHAIN_ID = "8217"; // Mainnet 8217, Testnet 1001
